import { makeStyles } from '@shared/theme';
import { HTMLAttributes } from 'react';

const useStyles = makeStyles(({ sizing }) => ({
  root: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    boxSizing: 'content-box',
  },
  'size-large': {
    // 28px
    width: sizing(7),
    // 21px
    height: sizing(5.25),
  },
  'size-medium': {
    // 24px
    width: sizing(6),
    // 18px
    height: sizing(4.5),
  },
  'size-small': {
    // 20px
    width: sizing(5),
    // 15px
    height: sizing(3.75),
  },
}));

type Props = HTMLAttributes<HTMLDivElement> & {
  size?: 'large' | 'medium' | 'small';
  sprites: number;
  offset: number;
};

const SpriteFlag: FC<Props> = ({
  className,
  size = 'medium',
  offset,
  sprites,
  style,
  ...restProps
}) => {
  const { classes, cx } = useStyles();
  return (
    <div
      className={cx(classes.root, classes[`size-${size}`], className)}
      style={{ ...style, backgroundPositionY: `${(100 * offset) / (sprites - 1)}%` }}
      {...restProps}
    />
  );
};

export default SpriteFlag;
